import { pxChangeVw } from "@/utils";
import { setCssVar } from "@/utils/setCssVar";
import { applyGooglePublisherTagPageConfig } from "@/components/common/GooglePublisherTag/pageLevelConfig";
export default function Anchor2(props: any) {
  let { slot: slot2, dataPosition } = props;
  useAdBodyClass(props.type, dataPosition);
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);
  let slotObj: any = null;
  useEffect(() => {
    if (!isMounted) return;
    setCssVar({
      key: "--privacy-policy-padding-bottom",
      value: `120px`,
    });
    // document.body.style = "padding-bottom: 0 !important;";
    console.log("slot2", slot2);
    window.googletag = window.googletag || { cmd: [] };
    googletag.cmd.push(function () {
      slotObj = googletag.defineOutOfPageSlot(slot2, googletag.enums.OutOfPageFormat.BOTTOM_ANCHOR);
      if (slotObj) slotObj.addService(googletag.pubads());
      applyGooglePublisherTagPageConfig();
      googletag.enableServices();
      googletag.display(slotObj);
      console.log("slotObj2", slotObj);
      window.googletag.pubads().addEventListener("slotRenderEnded", (event: any) => {
        if (event.slot.getSlotId().getName() === slot2) {
          let hasAdDisplayed = false;
          let retryCount = 0;
          const checkAdDisplay = () => {
            if (hasAdDisplayed) {
              return;
            }
            const timer = setTimeout(() => {
              const displayedAds = document.querySelectorAll('ins[data-anchor-status="displayed"]');
              // console.log(displayedAds);
              if (displayedAds.length) {
                hasAdDisplayed = true;
                setCssVar({
                  key: "--privacy-policy-padding-bottom",
                  value: `${(displayedAds?.[0]?.clientHeight ?? 100) + 30 + 25}px`,
                });
                return;
              }
              clearTimeout(timer);
              retryCount++;
              if (retryCount >= 10) {
                hasAdDisplayed = true;
              }
              checkAdDisplay();
            }, 300);
          };
          checkAdDisplay();
        }
      });
    });
    return () => {
      setCssVar({
        key: "--privacy-policy-padding-bottom",
        value: pxChangeVw(`30px`),
      });
      // removeStyle(document.body, "padding-bottom");
      googletag?.destroySlots?.([slotObj]);
      /*document.body.style.padding = `0`;
      const container = document.querySelector(".app-container");
      container.style.padding = `0`;*/
    };
  }, [isMounted]);
  /*useWatch3(els => {
    const bottomPaddingHeight = els[0].clientHeight + 25 + "px";
    // document.body.style = `padding: 0 0 ${bottomPaddingHeight}`;
    const container = document.querySelector(".app-container");
    container.style.padding = `0 0 ${bottomPaddingHeight}`;
    document.body.style.padding = `0`;
  });*/
  return <div className="fixed left-2000 bottom-0">{slot2}</div>;
}
